import React from 'react';
import Close from "@material-ui/icons/Close";
import Error from "@material-ui/icons/Error";
import Button from "assets/material-admin/components/CustomButtons/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import errorStyles from "assets/jss/components/Errors"
import Card from "assets/material-admin/components/Card/Card";
import CardBody from "assets/material-admin/components/Card/CardBody";
import CardHeader from "assets/material-admin/components/Card/CardHeader";

class Errors extends React.Component {
  render() {
    const {classes} = this.props    
    const errors = this.props.errors || []
    const errs = errors.map((e, idx) => {
      return (
        <div key={idx} className="error-item">          
          {e.message}
          <Button             
             onClick={() => {
               this.props.errors.splice(idx, 1)
               this.setState({errors: this.props.errors})
            }}
            className={classes.close}
            color="danger"
            justIcon
            size="sm"
            round >
            <Close />
          </Button>
        </div>
      )
    })
    return (
      (errs.length == 0) ? <span/>:
        <Card className={classes.errorCard} raised={true}>
        <CardHeader color="danger" className={classes.errorHeader}>
        <h4><Error
      color="inherit"
      className={classes.errorIcon}/> {errs.length > 1 ? "There were errors detected" : "There was an error"}</h4>
        </CardHeader>
        <CardBody>
        {errs}
        </CardBody>
        </Card>       
    )          
  }
}

export default withStyles(errorStyles)(Errors)
